var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.26 3.868c-.087-.592.08-1.93 1.45-2.535 1.712-.757 3.227-.165 3.852 1.185.626 1.35.132 3.096-1.613 5.104-1.397 1.607-2.207 2.404-2.438 2.601h3.556c.275-.044.843-.184.922-.395.08-.21.253-.439.33-.527h.329l-.89 2.668h-2.8c.594.911 1.476 3.392.264 6.026-1.514 3.293-5.005 3.424-6.355 3.457-1.08.028-2.382-.185-2.898-.295-.67.483-1.903 1.653-1.482 2.47.5.97 2.873.958 3.645.955h.109c.625 0 5.466.098 6.52.427 1.053.33 2.864.922 3.226 2.832.29 1.527-.78 2.194-1.35 2.337.077-.582-.046-1.805-1.152-2.042-1.066-.228-3.812-.358-5.77-.452-.583-.027-1.096-.052-1.474-.074-1.317-.08-2.92-.21-3.556-.265-.275.264-.922.995-1.317 1.811-.394.817-.427 1.57-.394 1.844L7 30.177a107 107 0 0 1 1.383-1.646A29.363 29.363 0 0 1 9.7 27.083c-.68-.23-2.002-1.054-1.844-2.503.158-1.45 2.173-3.195 3.161-3.886-.593-.165-2.002-.975-2.897-2.898-1.12-2.403-.66-4.906 1.12-6.848 1.777-1.943 3.983-2.338 6.387-2.272 1.923.052 3.194.79 3.589 1.152 1.108-1.043 3.352-3.595 3.457-5.466.132-2.337-2.041-2.239-2.963-2.041-.738.159-1.273 1.098-1.45 1.548zm-3.068 16.544c2.023-.174 3.456-2.73 3.2-5.708-.256-2.979-2.104-5.252-4.128-5.078-2.023.174-3.456 2.73-3.2 5.708.256 2.979 2.104 5.252 4.128 5.078z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrs);
export default __webpack_public_path__ + "static/media/GRS.f07d1d4f5565f9947228224ea82ee1dd.svg";
export { ForwardRef as ReactComponent };